import snakeCase from "lodash/snakeCase";
import mapKeys from "lodash/mapKeys";

export const toUnderscore = (obj = {}) => mapKeys(obj, (_, key) => snakeCase(key));
